import React, { useEffect, useState } from "react";
import { useCookies } from 'react-cookie';


export default function SetPage(){

    const [cookies] = useCookies(['uuid']);

    // 쿠키에서 UUID를 이용하여 사용자 정보 가져오기
    const[uid,setUID] = useState(0);
    const[nickname,setNickname] = useState('');

    useEffect(() => {
      if (!cookies.uuid) {
        alert('로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.');
        window.location.href = `/LoginAts`;
        return;
      } else {
        const uuid = cookies.uuid;
        fetchUserInfo(uuid);
      }
    }, []);

    useEffect(() => {
      console.log('클라이언트 uuid');
    }, [cookies.uuid]);

    useEffect(() => {
    if (uid !== 0) {
      console.log('uid 설정 이후 실행');
      onClickSearch_first();
      }
    }, [uid]);
  
    const fetchUserInfo = (uuid) => {
      fetch(`/SetPage/user?uuid=${uuid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          const user = data[0];
          setUID(user.uid);
          setNickname(user.nickname);
          fetchLists(user.uid);
          const possible = user.burst_possible;
          const nickname = user.nickname
          if (possible === '0' || possible === null || possible === 0){
            alert(`${nickname} 님은 Revolution version의 사용권한이 없습니다.`)
            window.location.href = `/SelectPage`;
            return;
            }
        })
        .catch(error => {
          alert('로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.');
          window.location.href = `/LoginAts`;
          return;
        });
    };

    // selectedlevel, entry, waiting list 받아오기
    const fetchLists = (uid) => {
      fetch(`/startcheck/searchlevel?uid=${uid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          if(data[0].super_user === "8"){
            setLevelCheck(data[0].super_user);  
          }else{
            setLevelCheck(data[0].selectedLevel);
          }
        })
        .catch(error => {
          console.error('Entry List 가져오기 오류:', error);
          alert(error);
        });

      fetch(`/startcheck_burst/list_entry?uid=${uid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          updateList(data, e_items, setE_Items);
        })
        .catch(error => {
          console.error('Entry List 가져오기 오류:', error);
          alert(error);
        });
  
      fetch(`/startcheck_burst/list_wait?uid=${uid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          updateList(data, w_items, setW_Items);
        })
        .catch(error => {
          console.error('Waiting List 가져오기 오류:', error);
          alert(error);
        });
    };
  
    const updateList = (data, list, setList) => {
      for (let i = 0; i < data.length; i++) {
        if (!isItemInList(data[i].symbol, list)) {
          setList(prevList => [...prevList, data[i].symbol]);
        }
      }
    };

    const isItemInList = (item, list) => {
      return list.includes(item);
    };

    const[symbol,setSymbol] = useState('default');
  
    const[auto_count,setSymbolCount] = useState(3);

    const[top_bottom,setTopBottom] = useState('top');

    const[position_mode,setPositionMode] = useState('isolated');

    const[funding_rate,setFundingRate] = useState('disable');
    const[f_percent_low,setFpercentLow] = useState(-100);
    const[f_percent_high,setFpercentHigh] = useState(0);

    const[entry_candle,setEntryCandle] = useState('3m');
    const[candle_style,setCandleStyle] = useState('both');
    const[candle_count,setCandleCount] = useState(20);
    const[candle_average_multiple,setCandleAverageMultiple] = useState(5);

    const[entry_ut,setEntryUt] = useState('disable');
    const[sensitivity_ut,setSensitivityUt] = useState(2);
    const[atr_period_ut,setAtrPeriodUt] = useState(2);
    const[candle_type_ut, setCandleTypeUt] = useState('haikin');
    const[ut_checking,setUtChecking] = useState(-1);

    const[leverage_info,setLeverage] = useState(10);

    ///////////////// LONG //////////////////////
    const [disabled_time, setDisabledTime] = useState('disable'); // 적용 여부
    const [start_time, setStartTime] = useState('00:00'); // 비가동 시작 시간
    const [close_time, setCloseTime] = useState('00:00'); // 비가동 종료 시간

    const[entry_standard,setEntryStandard] = useState('able');
    const[candle_standard,setCandleStandard] = useState('15m');
    const[candle_type_standard, setCandleTypeStandard] = useState('haikin');

    const[sensitivity,setSensitivity] = useState(2);
    const[atr_period,setAtrPeriod] = useState(2);

    const[close_type,setCloseType] = useState('kp');

    const[sensitivity_close,setSensitivityClose] = useState(2);
    const[atr_period_close,setAtrPeriodClose] = useState(2);

    const[close_candle,setCloseCandle] = useState('5m');

    const[candle_type_close, setCandleTypeClose] = useState('haikin');

    const[close_checking,setCloseChecking] = useState(-1);

    const[benefit_ratio,setBenefitRatio] = useState(0.35);
    const[benefit_ratio_absolute,setBenefitRatio_absolute] = useState(500);

    const[benefit_max_standard,setBenefitMaxStandard] = useState('no');
    const[benefit_max_ratio,setBenefitMaxRatio] = useState(100);
    const[benefit_min_ratio,setBenefitMinRatio] = useState(80);

    const[losscut_close_candle,setLosscutCloseCandle] = useState('3m');
    const[losscut_candle_count,setLosscutCandleCount] = useState(20);

    const[entry_usdt,setEntryUsdt] = useState(0);

    const[symbolCountValid,setSymbolCountValid] = useState(true);
    
    const[leverageValid,setLeverageValid] = useState(true);

    const[fPercentLowValid, setFpercentLowValid] = useState(true);
    const[fPercentHighValid, setFpercentHighValid] = useState(true);

    /////////////////valid//////////////////////
    const[sensitivityUtValid, setSensitivityUtValid] = useState(true);
    const[atrperiodUtValid, setAtrperiodUtValid] = useState(true);

    const[sensitivityValid, setSensitivityValid] = useState(true);
    const[atrperiodValid, setAtrperiodValid] = useState(true);

    const[candleCountValid,setCandleCountValid] = useState(true);
    const[candleAverageMultipleValid,setCandleAverageMultipleValid] = useState(true);

    const[sensitivityCloseValid, setSensitivityCloseValid] = useState(true);
    const[atrperiodCloseValid, setAtrperiodCloseValid] = useState(true);

    const[benefitratioValid, setBenefitratioValid] = useState(true);
    const[benefitratio_absoluteValid, setBenefitratio_absoluteValid] = useState(true);
    
    const[benefitmaxratioValid, setBenefitMaxRatioValid] = useState(true);
    const[benefitminratioValid, setBenefitMinRatioValid] = useState(true);

    const[losscutcandlecountValid, setLosscutCandleCountValid] = useState(true);

    //////////////////////////////////////////////

    const[entryusdtValid,setEntryUsdtValid] = useState(true);

    const[setlevel, setLevelCheck] = useState(0);
    const[notAllow, setNotAllow] = useState(true);

    const[e_items, setE_Items] = useState([]);
    const[w_items, setW_Items] = useState([]);

    const[trade_start,setTradeStart] = useState(false);
    
    const[benefit_stop,setBenefit_stop] = useState(false);
    const[benefit_cancel,setBenefit_cancel] = useState(false);

    const[currentCoin_stop,setCurrentCoin_stop] = useState(false);
    const[allCoin_stop,setAllCoin_stop] = useState(false);

    const[end,setEnd] = useState(false);
    
    // 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //

    const handleSymbolCount = (e) => {
      const newcount = e.target.value.trim();
      setSymbolCount(newcount);
        const regex = 
        /^\d*$/;
        if (regex.test(newcount)) {
          setSymbolCountValid(true);
          } 
        else {
          setSymbolCountValid(false);
          }
        };

    const handleDisableTime = (e) => {
      setDisabledTime(e.target.value);
    };

    const handleStartTime = (e) => {
      setStartTime(e.target.value);
    };

    const handleCloseTime = (e) => {
      setCloseTime(e.target.value);
    };

    const handleTopBotton = (e) => {
      setTopBottom(e.target.value);
        };

    const handlePositionMode = (e) => {
      setPositionMode(e.target.value);
        };

    const handleFundingRate = (e) => {
      setFundingRate(e.target.value);
        };

    const handleEntryStandard = (e) => {
      setEntryStandard(e.target.value);
    };

    const handleCandleStandard = (e) => {
      setCandleStandard(e.target.value);
    };

    const handleCandleTypeStandard = (e) => {
      setCandleTypeStandard(e.target.value);
    };

    const handleEntryCandle = (e) => {
      setEntryCandle(e.target.value);
        };

    const handleEntryUt = (e) => {
      setEntryUt(e.target.value);
        };

    const handleCandleTypeUt = (e) => {
      setCandleTypeUt(e.target.value);
        };

    const handleUtChecking = (e) => {
      setUtChecking(e.target.value);
        };

    const handleCandleStyle = (e) => {
      setCandleStyle(e.target.value);
        };

    const handleCloseType = (e) => {
      setCloseType(e.target.value);
        };
    
    const handleCloseCandle = (e) => {
      setCloseCandle(e.target.value);
        };
    
    const handleCloseChecking = (e) => {
      setCloseChecking(e.target.value);
        };
    
    const handleCandleTypeClose = (e) => {
      setCandleTypeClose(e.target.value);
        };

    const handleBenefitMaxStandard = (e) => {
      setBenefitMaxStandard(e.target.value);
        };
    
    const handleLosscutCloseCandle = (e) => {
      setLosscutCloseCandle(e.target.value);
        };

    const handleLeverage = (e) => {
      const newLeverage = e.target.value.trim();
      setLeverage(newLeverage);
        const regex = 
        /^\d*$/;
        if (regex.test(newLeverage)) {
          setLeverageValid(true);
          } 
        else {
          setLeverageValid(false);
          }
        };
    
    const handleCandleCount = (e) => {
      const newdata = e.target.value.trim();
      setCandleCount(newdata);
        const regex = 
        /^\d*$/;
        if (regex.test(newdata)) {
          setCandleCountValid(true);
          } 
        else {
          setCandleCountValid(false);
          }
        };
    
    const handleCandleAverageMultiple = (e) => {
      const newdata = e.target.value.trim();
      setCandleAverageMultiple(newdata);
        const regex = 
        /^\d*$/;
        if (regex.test(newdata)) {
          setCandleAverageMultipleValid(true);
          } 
        else {
          setCandleAverageMultipleValid(false);
          }
        };

    const handleFpercentLow = (e) => {
      const newPercent = e.target.value.trim();
      setFpercentLow(newPercent);

      const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
      if (regex.test(newPercent)) {
        setFpercentLowValid(true);
      } else {
        setFpercentLowValid(false);
      }
    };

    const handleFpercentHigh = (e) => {
      const newPercent = e.target.value.trim();
      setFpercentHigh(newPercent);

      const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
      if (regex.test(newPercent)) {
        setFpercentHighValid(true);
      } else {
        setFpercentHighValid(false);
      }
    };

    const handleSensitivityUt = (e) => {
      const newSensitivity = e.target.value.trim();
      setSensitivityUt(newSensitivity);
        const regex = 
        /^\d+$/;
        if (regex.test(newSensitivity)) {
          setSensitivityUtValid(true);
          } 
        else {
          setSensitivityUtValid(false);
          }
        };
    
    const handleAtrperiodUt = (e) => {
      const newdata = e.target.value.trim();
      setAtrPeriodUt(newdata);
        const regex = 
        /^\d+$/;
        if (regex.test(newdata)) {
          setAtrperiodUtValid(true);
          } 
        else {
          setAtrperiodUtValid(false);
          }
        };

    const handleSensitivity = (e) => {
      const newSensitivity = e.target.value.trim();
      setSensitivity(newSensitivity);
        const regex = 
        /^\d+$/;
        if (regex.test(newSensitivity)) {
          setSensitivityValid(true);
          } 
        else {
          setSensitivityValid(false);
          }
        };
    
    const handleAtrperiod = (e) => {
      const newdata = e.target.value.trim();
      setAtrPeriod(newdata);
        const regex = 
        /^\d+$/;
        if (regex.test(newdata)) {
          setAtrperiodValid(true);
          } 
        else {
          setAtrperiodValid(false);
          }
        };

    const handleSensitivityClose = (e) => {
      const newSensitivity = e.target.value.trim();
      setSensitivityClose(newSensitivity);
        const regex = 
        /^\d+$/;
        if (regex.test(newSensitivity)) {
          setSensitivityCloseValid(true);
          } 
        else {
          setSensitivityCloseValid(false);
          }
        };
    
    const handleAtrperiodClose = (e) => {
      const newdata = e.target.value.trim();
      setAtrPeriodClose(newdata);
        const regex = 
        /^\d+$/;
        if (regex.test(newdata)) {
          setAtrperiodCloseValid(true);
          } 
        else {
          setAtrperiodCloseValid(false);
          }
        };


    const handleBenefitratio = (e) => {
      const newBenefitratio = e.target.value.trim();
      setBenefitRatio(newBenefitratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newBenefitratio)) {
          setBenefitratioValid(true);
          } 
        else {
          setBenefitratioValid(false);
          }
        };
    
    const handleBenefitratio_absolute = (e) => {
      const newBenefitratio = e.target.value.trim();
      setBenefitRatio_absolute(newBenefitratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newBenefitratio)) {
          setBenefitratio_absoluteValid(true);
          } 
        else {
          setBenefitratio_absoluteValid(false);
          }
        };

    const handleEntryUsdt = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid(true);
          } 
        else {
          setEntryUsdtValid(false);
          }
        };
    
    const handleBenefitMaxRatio = (e) => {
      const newBenefitmaxratio = e.target.value.trim();
      setBenefitMaxRatio(newBenefitmaxratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newBenefitmaxratio)) {
          setBenefitMaxRatioValid(true);
          } 
        else {
          setBenefitMaxRatioValid(false);
          }
        };
    
    const handleBenefitMinRatio = (e) => {
      const newBenefitminratio = e.target.value.trim();
      setBenefitMinRatio(newBenefitminratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newBenefitminratio)) {
          setBenefitMinRatioValid(true);
          } 
        else {
          setBenefitMinRatioValid(false);
          }
        };

    const handleLosscutCandleCount = (e) => {
      const newdata = e.target.value.trim();
      setLosscutCandleCount(newdata);
        const regex = 
        /^\d+$/;
        if (regex.test(newdata)) {
          setLosscutCandleCountValid(true);
          } 
        else {
          setLosscutCandleCountValid(false);
          }
        };

    const addListItem = (newItem, listSetter) => {
      listSetter(prevList => [...prevList, newItem]);
    };

    const removeListItem = (itemName, listSetter) => {
      listSetter(prevList => prevList.filter(item => item !== itemName));
    };
    
    const onClickCoin = (coin) => {
      setSymbol(coin);
      onClickSearch(coin);
    }

    useEffect(() => {

      if(symbolCountValid && entryusdtValid && sensitivityUtValid && atrperiodUtValid && sensitivityValid && atrperiodValid && 
        sensitivityCloseValid && atrperiodCloseValid && leverageValid && benefitratioValid && benefitratio_absoluteValid && benefitmaxratioValid && 
        benefitminratioValid && fPercentLowValid && fPercentHighValid && losscutcandlecountValid && candleCountValid && candleAverageMultipleValid) {
        setNotAllow(false);
        return;
      }
      setNotAllow(true);
    }, [symbolCountValid, entryusdtValid, sensitivityUtValid, atrperiodUtValid, sensitivityValid, atrperiodValid, 
      sensitivityCloseValid, atrperiodCloseValid, leverageValid, benefitratioValid, benefitratio_absoluteValid, benefitmaxratioValid, 
      benefitminratioValid, fPercentLowValid, fPercentHighValid, losscutcandlecountValid, candleCountValid, candleAverageMultipleValid]);

    // symbol 값이 변경될 때마다 로그 출력
    useEffect(() => {
      console.log("symbol 값 변경:", symbol);
    }, [symbol]);

    const onClickSearch_first = () => {
      const uidurl = uid;
      fetch(`/setdata_first_burst/${uidurl}`)
      .then((response) => {
        if(!response.ok) {
          throw new Error('400 아니면 500 에러남');
        }
        return response.json()
      })
      .then((result) => {
        console.log('db에서 성공적으로 데이터 받아옴');
        setSymbolCount(result[0].auto_count);
        setTopBottom(result[0].top_bottom);
        setFundingRate(result[0].funding_rate);
        setFpercentLow(result[0].f_percent_low);
        setFpercentHigh(result[0].f_percent_high);

        setEntryCandle(result[0].entry_candle);
        setCandleStyle(result[0].candle_style);
        setCandleCount(result[0].candle_count);
        setCandleAverageMultiple(result[0].candle_average_multiple);

        setEntryUt(result[0].entry_ut);
        setSensitivityUt(result[0].sensitivity_ut);
        setAtrPeriodUt(result[0].atr_period_ut);
        setCandleTypeUt(result[0].candle_type_ut);
        setUtChecking(result[0].ut_checking);

        setEntryStandard(result[0].entry_standard);
        setCandleStandard(result[0].candle_standard);
        setCandleTypeStandard(result[0].candle_type_standard);
        setSensitivity(result[0].sensitivity);
        setAtrPeriod(result[0].atr_period);

        setCloseType(result[0].close_type);
        setSensitivityClose(result[0].sensitivity_close);
        setAtrPeriodClose(result[0].atr_period_close);
        setCloseCandle(result[0].close_candle);
        setCandleTypeClose(result[0].candle_type_close);
        setCloseChecking(result[0].close_checking);

        setEntryUsdt(result[0].entry_usdt);
        setLeverage(result[0].leverage_info);
        setPositionMode(result[0].position_mode);
        setBenefitRatio(result[0].benefit_ratio);
        setBenefitRatio_absolute(result[0].benefit_ratio_absolute);
        setBenefitMaxStandard(result[0].benefit_max_standard);
        setBenefitMaxRatio(result[0].benefit_max_ratio);
        setBenefitMinRatio(result[0].benefit_min_ratio);

        setLosscutCloseCandle(result[0].losscut_close_candle);
        setLosscutCandleCount(result[0].losscut_candle_count);

        setDisabledTime(result[0].disabled_time);
        setStartTime(result[0].start_time);
        setCloseTime(result[0].close_time);
      })
      .catch((error) => {
        console.error('에러남:', error.message || error);
      })
    }


    const onClickSearch = (symbol) => {
      let urlName
      const uidurl = uid;
      const str = symbol;
      console.log(str);
      if(str === 'default'){
        urlName = 'default'
      }else{
        const index = str.indexOf('/');
        urlName = str.substring(0,index);
      }  
      fetch(`/setdata_burst/${uidurl}/${urlName}/${setlevel}`)
      .then((response) => {
        if(!response.ok) {
          throw new Error('400 아니면 500 에러남');
        }
        return response.json()
      })
      .then((result) => {
        console.log('db에서 성공적으로 데이터 받아옴');
        
        setFundingRate(result[0].funding_rate);
        setFpercentLow(result[0].f_percent_low);
        setFpercentHigh(result[0].f_percent_high);

        setEntryCandle(result[0].entry_candle);
        setCandleStyle(result[0].candle_style);
        setCandleCount(result[0].candle_count);
        setCandleAverageMultiple(result[0].candle_average_multiple);

        setEntryUt(result[0].entry_ut);
        setSensitivityUt(result[0].sensitivity_ut);
        setAtrPeriodUt(result[0].atr_period_ut);
        setCandleTypeUt(result[0].candle_type_ut);
        setUtChecking(result[0].ut_checking);

        setEntryStandard(result[0].entry_standard);
        setCandleStandard(result[0].candle_standard);
        setCandleTypeStandard(result[0].candle_type_standard);
        setSensitivity(result[0].sensitivity);
        setAtrPeriod(result[0].atr_period);

        setCloseType(result[0].close_type);
        setSensitivityClose(result[0].sensitivity_close);
        setAtrPeriodClose(result[0].atr_period_close);
        setCloseCandle(result[0].close_candle);
        setCandleTypeClose(result[0].candle_type_close);
        setCloseChecking(result[0].close_checking);

        setEntryUsdt(result[0].entry_usdt);
        setLeverage(result[0].leverage_info);
        setPositionMode(result[0].position_mode);
        setBenefitRatio(result[0].benefit_ratio);
        setBenefitRatio_absolute(result[0].benefit_ratio_absolute);
        setBenefitMaxStandard(result[0].benefit_max_standard);
        setBenefitMaxRatio(result[0].benefit_max_ratio);
        setBenefitMinRatio(result[0].benefit_min_ratio);

        setLosscutCloseCandle(result[0].losscut_close_candle);
        setLosscutCandleCount(result[0].losscut_candle_count);

        setDisabledTime(result[0].disabled_time);
        setStartTime(result[0].start_time);
        setCloseTime(result[0].close_time);

        setTradeStart(result[0].trade_start);
        setBenefit_stop(result[0].current_symbol_stop);
        setCurrentCoin_stop(result[0].current_coin_clear);
        setAllCoin_stop(result[0].all_coin_clear);
        setEnd(result[0].end);

        const e_checklist = isItemInList(result[0].symbol, e_items);
        const w_checklist = isItemInList(result[0].symbol, w_items);
        
        if(str !== 'default'){
          result.forEach(item => {
            // console.log('item',item)
            if ((item.trade_start === 1 || item.trade_start === '1') && e_checklist === false) {
              addListItem(item.symbol, setE_Items);
            }
            if ((item.trade_start === 0 || item.trade_start === '0') && e_checklist === true) {
              removeListItem(item.symbol, setE_Items);
            }
          
            // Waiting coin 리스트 삽입 및 삭제
            if ((item.current_symbol_stop === 1 || item.current_symbol_stop === '1') && w_checklist === false) {
              addListItem(item.symbol, setW_Items);
            }
            if ((item.current_symbol_stop === 0 || item.current_symbol_stop === '0') && w_checklist === true) {
              removeListItem(item.symbol, setW_Items);
            }
          });
        };

        console.log('e_items',e_items);
        console.log('e_checklist',e_checklist);
      })
      .catch((error) => {
        console.error('에러남:', error.message || error);
      })
    }

    const onClickStart = () => {

      let confirmed = false

      confirmed = window.confirm('버스트버전 자동매매를 시작하시겠습니까?');

      if (confirmed) {
        console.log('스타트 버튼 클릭')
        fetch('/start_burst', {
          method : 'POST',
          headers: {
            'Content-Type' : 'application/json',
          },
          body: JSON.stringify({
            uid,
            auto_count,
            top_bottom,
            funding_rate,
            f_percent_low,
            f_percent_high,
            entry_candle,
            candle_style,
            candle_count,
            candle_average_multiple,
            entry_ut,
            sensitivity_ut,
            atr_period_ut,
            candle_type_ut,
            ut_checking,
            entry_standard,
            candle_standard,
            candle_type_standard,
            sensitivity,
            atr_period,
            close_type,
            sensitivity_close,
            atr_period_close,
            close_candle,
            candle_type_close,
            close_checking,
            entry_usdt,
            leverage_info,
            position_mode,
            benefit_ratio,
            benefit_ratio_absolute,
            benefit_max_standard,
            benefit_max_ratio,
            benefit_min_ratio,
            losscut_close_candle,
            losscut_candle_count,
            disabled_time,
            start_time,
            close_time
          }),
         })
         .then(response => response.json())  // 응답을 JSON 형식으로 변환
         .then(data => {
          alert(data.message);  // JSON에서 message 값을 가져옴
         })
         .catch(error => console.error('Error:', error));
       };
      onClickSearch_first();
    };

    const onClickStop = () => {

      let confirmed = false

      confirmed = window.confirm('버스트 버전 자동매매를 종료하시겠습니까? 종료하시면 프로그램 자체가 종료되므로 수동으로 포지션 정리하셔야 합니다.');

      if (confirmed) {
        console.log('종료 버튼 클릭')
        fetch('/stop_burst', {
          method : 'POST',
          headers: {
            'Content-Type' : 'application/json',
          },
          body: JSON.stringify({
            uid
            }),
         })
         .then(response => response.json())  // 응답을 JSON 형식으로 변환
         .then(data => {
          alert(data.message);  // JSON에서 message 값을 가져옴
         })
         .catch(error => console.error('Error:', error));
       };

      onClickSearch_first();
    };

    // 익절 후 정리
    const onClickBenefit_stop = (symbol) => {
      const confirmed = window.confirm('Do you want to clean up the selected coin after profiting?');

      if (confirmed) {
        setBenefit_stop(true);
        let urlName
        const str = symbol;
        console.log(str);
        const uidurl = uid;
        if(str === 'default'){
          urlName = 'default'
        }else{
          const index = str.indexOf('/');
          urlName = str.substring(0,index);
        }
        fetch(`/setdata_benefit_burst/${uidurl}/${urlName}/${setlevel}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('benefit에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
          })
        };
      onClickSearch(symbol);
    }

    // 익절 후 정리 취소 
    const onClickBenefit_cancel = (symbol) => {
      const confirmed = window.confirm('Do you want to cancel clearing after profiting the selected coins?');

      if (confirmed) {
        setBenefit_cancel(true);
        let urlName
        const str = symbol;
        console.log(str);
        const uidurl = uid;
        if(str === 'default'){
          urlName = 'default'
        }else{
          const index = str.indexOf('/');
          urlName = str.substring(0,index);
        }
        fetch(`/setdata_benefit_cancel_burst/${uidurl}/${urlName}/${setlevel}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('benefit_cancel에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
        })
      };
      onClickSearch(symbol);
    }

    // 현재 코인 정리 
    const onClickCurrentCoin_stop = (symbol) => {
      const confirmed = window.confirm('Would you like to liquidate the selected coins right away?');

      if (confirmed) {
        setCurrentCoin_stop(true);
        const str = symbol;
        console.log(str);
        const uidurl = uid;
        const index = str.indexOf('/');
        const urlName = str.substring(0,index);
        fetch(`/setdata_current_coin_clear_burst/${uidurl}/${urlName}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('current_stop에서 받아온 데이터');
        })
        .catch((error) => {
          console.log('에러남');
        })
      };
      onClickSearch(symbol);
    }


    //로그아웃
    const onClickEnd = () => {
        const uuid = cookies.uuid; // cookies에서 uuid를 얻어옴
        if (!uuid) {
          alert('로그인 정보가 존재하지 않습니다.');
          return;
        }
        // 로그아웃 요청을 서버로 보냅니다.
        fetch('/logout', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ userId: uuid })
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('로그아웃 요청 실패');
          }
          console.log('로그아웃 성공');
          alert('Logout is successful.');
          window.location.href = '/';
        })
        .catch(error => {
          console.error('로그아웃 요청 중 오류 발생:', error);
        });
      // UUID를 서버로 보내는 예시 코드

    }

    return (
        <div className="page_sp_leverage">
          <div className="title_top_sp">
            <div></div>
            <div className="titleWrap_sp_lever">
            Auto trade system (Burst version)</div>
            <div className="inputTitle_uid_lever">
                <span>UID : {uid}</span>
                <span>{nickname}님 환영합니다</span>
            </div>
          </div>

          <div className="line_top"></div>

            <div className="container">
              <div className="column_leverage">
            <div className="contentWrap_sp">

            <div className="center_text_lever">Basic setting(Burst)</div>
                <div class="leverage_container">
                  <div class="leverage_item">자동코인 갯수</div>
                    <input 
                    type="number" 
                    class="leverage_input_basic"
                    value={auto_count}
                    onChange={handleSymbolCount} />
                  <div class="leverage_item">상하위 선택</div>
                    <select className="select_samaria" value={top_bottom} onChange={handleTopBotton}>
                    <option value="top">상위</option>
                    <option value="bottom">하위</option>
                    </select>
                </div>

                <div class="leverage_container">
                  <div class="leverage_item">펀딩비율</div>
                  <select className="select_samaria" value={funding_rate} onChange={handleFundingRate}>
                  <option value="disable">미적용</option>
                  <option value="able">적용</option>
                  </select>
                  <div class="leverage_item"style={{
                    filter: (funding_rate === 'disable') ? 'blur(5px)' : 'none',
                    }}>사이값</div>
                  <input 
                  type="number"
                  class="leverage_input_basic"
                  value={f_percent_low}
                  readOnly={funding_rate === 'disable'}
                  style={{
                    filter: (funding_rate === 'disable') ? 'blur(5px)' : 'none',
                    }}
                  onChange={handleFpercentLow} />
                  <div class="leverage_item"style={{
                    filter: (funding_rate === 'disable') ? 'blur(5px)' : 'none',
                    }}>부터</div>
                  <input 
                  type="number" 
                  class="leverage_input_basic"
                  value={f_percent_high}
                  readOnly={funding_rate === 'disable'}
                  style={{
                    filter: (funding_rate === 'disable') ? 'blur(5px)' : 'none',
                    }}
                  onChange={handleFpercentHigh} />
                  <div class="leverage_item"style={{
                    filter: (funding_rate === 'disable') ? 'blur(5px)' : 'none',
                    }}>까지</div>
                </div>

                <div className="line"></div>

                <div className="leverage_container">
                  <div class="leverage_item">진입 계산 시간봉</div>
                    <select className="select_samaria" value={entry_candle} onChange={handleEntryCandle}>
                    <option value="1m">1 분봉</option>
                    <option value="3m">3 분봉</option>
                    <option value="5m">5 분봉</option>
                    <option value="15m">15 분봉</option>
                    <option value="30m">30 분봉</option>
                    <option value="1h">1 시간봉</option>
                    <option value="4h">4 시간봉</option>
                    </select>
                  <div class="leverage_item">카운팅 봉스타일</div>
                    <select className="select_samaria" value={candle_style}
                      onChange={handleCandleStyle}>
                      <option value="both">모든봉</option>
                      <option value="plus">양봉만</option>
                    </select>
                </div>
                <div className="leverage_container">
                  <div class="leverage_item">평균봉갯수</div>
                    <input 
                      type="number"
                      class="leverage_input_basic"
                      value={candle_count}
                      onChange={handleCandleCount}/>
                  <div class="leverage_item">Burst수치(배수)</div>
                    <input 
                      type="number"
                      class="leverage_input_basic"
                      value={candle_average_multiple}
                      onChange={handleCandleAverageMultiple}/>
                </div>

                <div className="leverage_container">
                  <div class="leverage_item">UT신호적용</div>
                    <select className="select_samaria" value={entry_ut} onChange={handleEntryUt}>
                    <option value="able">적용</option>
                    <option value="disable">미적용</option>
                    </select>
                  <div class="leverage_item" disabled={entry_ut === 'disable'}
                      style={{
                      filter: (entry_ut === 'disable') ? 'blur(5px)' : 'none',
                      }} >Sensitivity</div>
                     <input 
                      type="number"
                      class="leverage_input_basic"
                      value={sensitivity_ut}
                      disabled={entry_ut === 'disable'}
                      style={{
                      filter: (entry_ut === 'disable') ? 'blur(5px)' : 'none',
                      }}
                      onChange={handleSensitivityUt} />
                  <div class="leverage_item"disabled={entry_ut === 'disable'}
                      style={{
                      filter: (entry_ut === 'disable') ? 'blur(5px)' : 'none',
                      }}>ATR Period</div>
                    <input 
                      type="number"
                      class="leverage_input_basic"
                      value={atr_period_ut}
                      disabled={entry_ut === 'disable'}
                      style={{
                      filter: (entry_ut === 'disable') ? 'blur(5px)' : 'none',
                      }}
                      onChange={handleAtrperiodUt} />
                </div>

                <div className="leverage_container">
                  <div class="leverage_item" disabled={entry_ut === 'disable'}
                      style={{
                      filter: (entry_ut === 'disable') ? 'blur(5px)' : 'none',
                      }}>UT 진입기준</div>
                    <select className="select_samaria"
                      disabled={entry_ut === 'disable'}
                        style={{
                        filter: (entry_ut === 'disable') ? 'blur(5px)' : 'none',
                        }} 
                      value={candle_type_ut} onChange={handleCandleTypeUt}>
                      <option value="haikin">하이킨아시</option>
                      <option value="normal">일반봉</option>
                    </select>
                  <div class="leverage_item"disabled={entry_ut === 'disable'}
                      style={{
                      filter: (entry_ut === 'disable') ? 'blur(5px)' : 'none',
                      }}>UT 진입 신호</div>
                    <select className="select_samaria" 
                      disabled={entry_ut === 'disable'}
                      style={{
                      filter: (entry_ut === 'disable') ? 'blur(5px)' : 'none',
                      }}
                      value={ut_checking} onChange={handleUtChecking}>
                    <option value="-1">발생</option>
                    <option value="-2">확정</option>
                    </select>
                </div>

              <div className="line"></div>

              <div class="leverage_container">
                <div class="leverage_item">보조기준</div>
                  <select className="select_samaria" 
                  onChange={handleEntryStandard}>
                  <option value="able">적용</option>
                  <option value="disable">미적용</option>
                  </select>
                <div class="leverage_item" style={{
                   filter: (entry_standard === 'disable') ? 'blur(5px)' : 'none',
                  }}>보조 기준 시간봉</div>
                  <select className="select_samaria" value={candle_standard} 
                  style={{
                    filter: (entry_standard === 'disable') ? 'blur(5px)' : 'none',
                    }} 
                    onChange={handleCandleStandard}>
                  <option value="1m">1 분봉</option>
                  <option value="3m">3 분봉</option>
                  <option value="5m">5 분봉</option>
                  <option value="15m">15 분봉</option>
                  <option value="30m">30 분봉</option>
                  <option value="1h">1 시간봉</option>
                  <option value="4h">4 시간봉</option>
                  </select>
                <div class="leverage_item" style={{
                    filter: (entry_standard === 'disable') ? 'blur(5px)' : 'none',
                  }}>UT 보조 기준</div>
                  <select className="select_samaria" 
                  value={candle_type_standard} 
                  readOnly={entry_standard === 'disable'}
                  style={{
                    filter: (entry_standard === 'disable') ? 'blur(5px)' : 'none',
                  }}
                  onChange={handleCandleTypeStandard}>
                  <option value="haikin">하이킨아시</option>
                  <option value="normal">일반봉</option>
                  </select>
              </div>

                <div class="leverage_container">
                  <div class="leverage_item"style={{
                    filter: (entry_standard === 'disable') ? 'blur(5px)' : 'none',
                  }}>Sensitivity</div>
                  <input 
                  type="number"
                  class="leverage_input_basic"
                  value={sensitivity}
                  readOnly={entry_standard === 'disable'}
                  style={{
                    filter: (entry_standard === 'disable') ? 'blur(5px)' : 'none',
                    }}
                  onChange={handleSensitivity} />
                  <div class="leverage_item"style={{
                    filter: (entry_standard === 'disable') ? 'blur(5px)' : 'none',
                    }}>ATR Period</div>
                  <input 
                  type="number" 
                  class="leverage_input_basic"
                  value={atr_period}
                  readOnly={entry_standard === 'disable'}
                  style={{
                    filter: (entry_standard === 'disable') ? 'blur(5px)' : 'none',
                    }}
                  onChange={handleAtrperiod} />
                </div>
              
              <div className="line"></div>

              <div class="leverage_container">
                <div class="leverage_item">익절기준</div>
                <select className="select_samaria" 
                value={close_type} 
                onChange={handleCloseType}>
                <option value="kp">킨포인트</option>
                <option value="ut">UT 신호</option>
                </select>
                <div class="leverage_item">Sensitivity</div>
                <input 
                type="number"
                class="leverage_input_basic"
                value={sensitivity_close}
                readOnly={close_type === 'kp'}
                 style={{
                   filter: (close_type === 'kp') ? 'blur(5px)' : 'none',
                  }}
                onChange={handleSensitivityClose} />
                <div class="leverage_item"style={{
                   filter: (close_type === 'kp') ? 'blur(5px)' : 'none',
                  }}>ATR Period</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={atr_period_close}
                readOnly={close_type === 'kp'}
                 style={{
                   filter: (close_type === 'kp') ? 'blur(5px)' : 'none',
                  }}
                onChange={handleAtrperiodClose} />
              </div>

              <div className="leverage_container">
                <div class="leverage_item">익절 기준 시간봉</div>
                  <select className="select_samaria" 
                    value={close_candle} onChange={handleCloseCandle}>
                    <option value="1m">1 분봉</option>
                    <option value="3m">3 분봉</option>  
                    <option value="5m">5 분봉</option>
                    <option value="15m">15 분봉</option>
                    <option value="30m">30 분봉</option>
                    <option value="1h">1 시간봉</option>
                    <option value="4h">4 시간봉</option>
                  </select>
                <div class="leverage_item">UT 익절 기준</div>
                <select className="select_samaria" 
                  disabled={close_type === 'kp'}
                  style={{
                   filter: (close_type === 'kp') ? 'blur(5px)' : 'none',
                  }} 
                  value={candle_type_close} onChange={handleCandleTypeClose}>
                  <option value="haikin">하이킨아시</option>
                  <option value="normal">일반봉</option>
                </select>
                <div class="leverage_item" style={{
                   filter: (close_type === 'kp') ? 'blur(5px)' : 'none',
                  }}>UT 익절 신호</div>
                <select className="select_samaria" 
                  disabled={close_type === 'kp'}
                  style={{
                   filter: (close_type === 'kp') ? 'blur(5px)' : 'none',
                  }} 
                  value={close_checking} onChange={handleCloseChecking}>
                <option value="-1">발생</option>
                <option value="-2">확정</option>
                </select>
              </div>

              <div className="line"></div>

              <div className="leverage_container">
                <div class="leverage_item">진입 USDT</div>
                  <input 
                  type="number"
                  step="1"
                  class="leverage_input_basic"
                  value={entry_usdt}
                  onChange={handleEntryUsdt} />
                <div class="leverage_item">Leverage set</div>
                  <input 
                  type="number" 
                  class="leverage_input_basic"
                  value={leverage_info}
                  onChange={handleLeverage} />
                  <div class="leverage_item">청산모드 선택</div>
                  <select className="select_samaria" value={position_mode} onChange={handlePositionMode}>
                  {/* <option value="cross">교차모드</option> */}
                  <option value="isolated">격리모드</option>
                  </select>
              </div>

              <div className="leverage_container">
                <div class="leverage_item">최소 익절(%)</div>
                  <input 
                  type="number"
                  class="leverage_input_basic"
                  value={benefit_ratio}
                  onChange={handleBenefitratio} />
                <div class="leverage_item">절대 익절(%)</div>
                  <input 
                  type="number"
                  class="leverage_input_basic"
                  value={benefit_ratio_absolute}
                  onChange={handleBenefitratio_absolute} />
              </div>

              <div className="leverage_container">
                <div class="leverage_item">최대 익절 설정</div>
                <select className="select_samaria" value={benefit_max_standard} 
                  onChange={handleBenefitMaxStandard}>
                <option value="no">미적용</option>
                <option value="available">적용</option>
                </select>
                <div class="leverage_item" style={{
                  filter: (benefit_max_standard !== 'available') ? 'blur(5px)' : 'none',
                }} >익절 기준(%)</div>
                <input
                 className="leverage_input_basic"
                 value={benefit_max_ratio}
                 readOnly={benefit_max_standard !== 'available'}
                 style={{
                   filter: (benefit_max_standard !== 'available') ? 'blur(5px)' : 'none',
                  }}
                onChange={handleBenefitMaxRatio}
                />
                <div class="leverage_item" style={{
                  filter: (benefit_max_standard !== 'available') ? 'blur(5px)' : 'none',
                }}>정리 기준(%)</div>
                <input
                 className="leverage_input_basic"
                 value={benefit_min_ratio}
                 readOnly={benefit_max_standard !== 'available'}
                 style={{
                   filter: (benefit_max_standard !== 'available') ? 'blur(5px)' : 'none',
                  }}
                onChange={handleBenefitMinRatio}
                />
              </div>

              <div className="line"></div>

              <div class="leverage_container">
                <div class="leverage_item">손절 기준 시간봉</div>
                  <select className="select_samaria" value={losscut_close_candle} onChange={handleLosscutCloseCandle}>
                  <option value="1m">1 분봉</option>
                  <option value="3m">3 분봉</option>  
                  <option value="5m">5 분봉</option>
                  <option value="15m">15 분봉</option>
                  <option value="30m">30 분봉</option>
                  <option value="1h">1 시간봉</option>
                  <option value="4h">4 시간봉</option>
                  </select>
                <div class="leverage_item">손절 기준 봉갯수</div>
                  <input 
                  type="number"
                  class="leverage_input_basic"
                  value={losscut_candle_count}
                  onChange={handleLosscutCandleCount} />
              </div>

              <div class="leverage_container">
                  <div class="leverage_item">비가동 시간</div>
                  <select className="select_samaria" value={disabled_time} onChange={handleDisableTime}>
                  <option value="disable">미적용</option>
                  <option value="able">적용</option>
                  </select>
                  <div class="leverage_item"style={{
                    filter: (disabled_time === 'disable') ? 'blur(5px)' : 'none',
                    }}>시간</div>
                  <input 
                  type="time"
                  class="leverage_input_basic_time"
                  value={start_time}
                  readOnly={disabled_time === 'disable'}
                  style={{
                    filter: (disabled_time === 'disable') ? 'blur(5px)' : 'none',
                    }}
                  onChange={handleStartTime} />
                  <div class="leverage_item"style={{
                    filter: (disabled_time === 'disable') ? 'blur(5px)' : 'none',
                    }}>~</div>
                  <input 
                  type="time" 
                  class="leverage_input_basic_time"
                  value={close_time}
                  readOnly={disabled_time === 'disable'}
                  style={{
                    filter: (disabled_time === 'disable') ? 'blur(5px)' : 'none',
                    }}
                  onChange={handleCloseTime} />
              </div>

              <div className="line"></div>

              <div className="leverage_container_center"> 
                  <input
                  type="text"
                  class="leverage_input_basic_meme"
                  value={symbol === 'default' ? '' : symbol}
                  readOnly={true}
                  />
                {/* <button onClick={() => onClickModify(symbol)} disabled={symbol === 'default'} className="button_benefit_c_meme">
                선택 코인 셋팅 변경
                </button> */}
              </div>

              <div className="line"></div>

            </div>

            <div className="leverage_container"></div>
            <div className="button_benefit_leverage">
                <button onClick={() => onClickStart()} className="button_benefit_c_lever">
                자동 매매 시작
                </button>
                <button onClick={() => onClickStop()} className="button_benefit_c_lever">
                자동 매매 종료
                </button>
            </div>

            <div className="button_benefit_leverage">
                <button onClick={() => onClickBenefit_stop(symbol)} disabled={benefit_stop === 1 || trade_start === 0 || benefit_stop === '1' || trade_start === '0'} className="button_benefit_c_lever">
                익절 후 정리
                </button>
                <button onClick={() => onClickBenefit_cancel(symbol)} disabled={benefit_stop === '0' || benefit_stop === 0} className="button_benefit_c_lever">
                취 소
                </button>
            </div>

            <div className="button_benefit_leverage">
                <button onClick={() => onClickCurrentCoin_stop(symbol)} disabled={(symbol === 'default' && trade_start === 0 &&  benefit_stop === 0) || (symbol === 'default' && trade_start === '0' &&  benefit_stop === '0') || setlevel <= 7} className="bottomButton_sp_lever">
                현재 코인 정리
                </button>
                {/* <button onClick={() => onClickAllCoin_stop()} disabled={symbol === 'default' && setlevel <= 7} className="button_benefit_c_lever">
                All symbol close
                </button> */}
            </div>

            <div className="button_benefit_leverage">
                <button onClick={() => onClickEnd()} disabled={notAllow} className="bottomButton_sp_lever">
                로그아웃
                </button>
             </div>
          </div>


          <div className="column_leverage">
              <div className="list_box_title_lever">진입중인 코인 리스트</div>
              <ul className="list_box_lever">
                {e_items.map((item, index) => (
                  <li
                    key={index}
                    className="list_item"
                    onClick={() => onClickCoin(item)}
                  >
                    {item}
                  </li>
                ))}
              </ul>
          </div>

          <div className="column_leverage">
            <div className="list_box_title_lever">익절 후 정리 리스트</div>
              <ul className="list_box_lever">
                {w_items.map((item, index) => (
                  <li
                    key={index}
                    className="list_item"
                    onClick={() => onClickCoin(item)}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
    );
}